import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_DETAILS_PATH_KEY } from '@/swagger/constants/contents-orchestrator-keys';
import { KEY_GET_CONTENT_DETAILS, API_GET_CONTENT_DETAILS } from '../constants';
import { MOCK_RESPONSE_GET_CONTENT_DETAILS } from '../mocks';

type API_GET_CONTENT_DETAILS_PROPS = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_DETAILS_PATH_KEY
>;

export type RequestGetContentDetails = API_GET_CONTENT_DETAILS_PROPS['request']['path'];

export type ResponseGetContentDetails = API_GET_CONTENT_DETAILS_PROPS['response']['body'];

export type CallParamsGetContentDetails = Omit<RequestGetContentDetails, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseGetContentDetails = ResponseGetContentDetails;

type CallErrorGetContentDetails = {
  message: string;
  code: number;
  type: string;
  title: string;
  status: number;
};

type CallSelectorsGetContentDetails = {
  data?: CallResponseGetContentDetails;
};

export const getContentDetailsCall = createGeneralCall<
  CallParamsGetContentDetails,
  CallResponseGetContentDetails,
  CallErrorGetContentDetails,
  CallSelectorsGetContentDetails
>({
  id: KEY_GET_CONTENT_DETAILS,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_CONTENT_DETAILS(org as unknown as string, payload.contentId);
    },
  method: 'get',
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  selectors: {
    data: ({ selectors }) => createSelector(selectors.response, res => res || undefined),
  },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_CONTENT_DETAILS : undefined,
});
